"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFPStatusLabels = exports.RFPStatuses = exports.RFPStatus = exports.RFPQuery = exports.RFPUpdate = exports.RFPCreate = exports.RFPTransportWayste = exports.RFPTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const meta_data_1 = require("../common/meta-data");
const rfp_common_types_1 = require("./rfp-common-types");
Object.defineProperty(exports, "RFPStatus", { enumerable: true, get: function () { return rfp_common_types_1.RFPStatus; } });
Object.defineProperty(exports, "RFPStatusLabels", { enumerable: true, get: function () { return rfp_common_types_1.RFPStatusLabels; } });
Object.defineProperty(exports, "RFPStatuses", { enumerable: true, get: function () { return rfp_common_types_1.RFPStatuses; } });
const rfp_sku_1 = require("./rfp-sku");
// Use a placeholder for the vendor response array to break the circular dependency
const RFPVendorResponseBase = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    rfpID: typebox_1.Type.String({ format: 'uuid' }),
    vendorID: typebox_1.Type.String({ format: 'uuid' }),
    vendorName: typebox_1.Type.String(),
    status: rfp_common_types_1.RFPStatus,
    accessLink: typebox_1.Type.String(),
    rfpSkus: typebox_1.Type.Array(rfp_sku_1.RFPSkuTransport),
    /**
     * Should be the same as the RFP deadlineDate
     */
    accessLinkExpirationDate: typebox_1.Type.String({ format: 'date-time' }),
    voidMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    awardMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    lostMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    declinedMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    noteToVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    noteFromVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    awardDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: meta_data_1.MetaData,
});
exports.RFPTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    familyID: typebox_1.Type.String({ format: 'uuid' }),
    noteToVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    proposalNumber: typebox_1.Type.Integer(),
    serviceLocation: common_1.ServiceLocationTransport,
    businessType: typebox_1.Type.Optional(typebox_1.Type.String()),
    targetProposalAmount: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    status: rfp_common_types_1.RFPStatus,
    deadlineDate: typebox_1.Type.String({ format: 'date-time' }),
    rfpSkus: typebox_1.Type.Array(rfp_sku_1.RFPSkuTransport),
    /**
     * The vendor that is currently on the site, if any, that we are taking the stop from
     */
    currentVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    rfpVendorResponses: typebox_1.Type.Array(RFPVendorResponseBase),
    forLeadID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    forCustomerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    forVendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    serviceStartDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    voidDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    awardDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: meta_data_1.MetaData,
    images: typebox_1.Type.Array(common_1.S3ItemReference),
    rfpName: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.RFPTransportWayste = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPTransport, [
        'familyID',
        'forLeadID',
        'forCustomerID',
        'forVendorID',
        'status',
        'rfpSkus',
        'rfpVendorResponses',
        'currentVendor',
        'rfpName',
    ]),
]);
exports.RFPCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPTransport, ['id', 'voidDate', 'metadata', 'awardDate', 'proposalNumber', 'rfpSkus', 'images']),
    typebox_1.Type.Object({
        rfpSkus: typebox_1.Type.Array(typebox_1.Type.Intersect([typebox_1.Type.Omit(rfp_sku_1.RFPSkuCreate, ['rfpID'])])),
        images: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    }),
]);
exports.RFPUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPCreate, ['forLeadID', 'forCustomerID', 'forVendorID', 'familyID', 'targetProposalAmount']),
    typebox_1.Type.Object({
        awardDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
        targetProposalAmount: (0, common_1.Nullable)(typebox_1.Type.Integer()),
    }),
]));
exports.RFPQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    limit: typebox_1.Type.Integer(),
    offset: typebox_1.Type.Integer(),
    orderBy: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('createdAt'), typebox_1.Type.Literal('lastUpdatedAt')])),
    reverseSort: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    forLeadID: typebox_1.Type.String({ format: 'uuid' }),
    forCustomerID: typebox_1.Type.String({ format: 'uuid' }),
    forVendorID: typebox_1.Type.String({ format: 'uuid' }),
    /**
     * Either pass an array of actual RFPStatus OR true for things with a status OR false with things with no status
     * Needs to be a comma separated list of type RFPStatus. Use [].join(',')
     */
    status: typebox_1.Type.Union([typebox_1.Type.Boolean(), typebox_1.Type.String({ minLength: 1 })]),
    createdBefore: typebox_1.Type.String({ format: 'date-time' }),
    createdAfter: typebox_1.Type.String({ format: 'date-time' }),
    voidDate: typebox_1.Type.String({ format: 'date-time' }),
    awardDate: typebox_1.Type.String({ format: 'date-time' }),
    serviceStartDate: typebox_1.Type.String({ format: 'date-time' }),
}));
//# sourceMappingURL=rfp.js.map